import {
  ButtonDS,
  RemoveRedEyeOutlined,
  DialogModalDS,
  FilePresentOutlined,
  Spacer,
  MessageTooltip,
  ArticleOutlined,
} from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { PublicTransactionsPropsType } from "../transactionsAPI";
import {
  transactionsSlice,
  selectSupportingDocumentUrl,
  selectIsSupportingDocumentPdf,
} from "../transactionsSlice";
import styled from "styled-components";

export const SupportingDocumentModal = (props: {
  supportingDocumentUuid: string;
  transaction: PublicTransactionsPropsType;
  sendSmsReplaceInvalidAction: (props: {
    driverPhone: string;
    driverName: string;
    transactionUuid: string;
  }) => void;
  getSupportingDocumentAction: (supportingDocumentUuid: string) => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const supportingDocumentUrl = useAppSelector(selectSupportingDocumentUrl);
  const isSupportingDocumentPdf = useAppSelector(selectIsSupportingDocumentPdf);

  return (
    <>
      <ButtonDS
        format="fill"
        buttonType="secondary"
        text={t("transactions.informations.download")}
        leftIcon={<RemoveRedEyeOutlined />}
        onClick={() =>
          props.getSupportingDocumentAction(props.supportingDocumentUuid)
        }
      />
      {supportingDocumentUrl && (
        <DialogModalDS
          visible={!!supportingDocumentUrl}
          onClose={() => {
            dispatch(transactionsSlice.actions.resetSupportingDocumentUrl());
          }}
          title={t("transactions.informations.modal.title")}
          subTitle={t("transactions.informations.modal.subTitle")}
          iconTitle={<FilePresentOutlined />}
        >
          <StyledModal>
            {isSupportingDocumentPdf ? (
              <iframe src={supportingDocumentUrl} />
            ) : (
              <StyledImage src={supportingDocumentUrl} />
            )}
            <Spacer y={1.5} />
            <MessageTooltip
              title={t(
                "transactions.informations.modal.message.invalid.document.title",
              )}
              text={t(
                "transactions.informations.modal.message.invalid.document.text",
              )}
              type="INFORMATIVE"
              button={
                <ButtonDS
                  buttonType="secondary"
                  format="fill"
                  leftIcon={<ArticleOutlined />}
                  text={t(
                    "transactions.informations.modal.message.invalid.document.button",
                  )}
                  disabled={!props.transaction.driverName}
                  onClick={() => {
                    props.transaction.driverPhone &&
                      props.sendSmsReplaceInvalidAction({
                        driverPhone: props.transaction.driverPhone,
                        driverName: props.transaction.driverName ?? "",
                        transactionUuid: props.transaction.uuid,
                      }),
                      dispatch(
                        transactionsSlice.actions.resetTransactionsListStatus(),
                      );
                  }}
                />
              }
            />
          </StyledModal>
        </DialogModalDS>
      )}
    </>
  );
};

const StyledModal = styled.div`
  width: 100%;
  iframe {
    min-width: 100%;
    height: 45rem;
    border-radius: 0.5rem;
  }
`;

const StyledImage = styled.img`
  border-radius: 0.5rem;
  width: 100%;
`;
